import script from "./myTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./myTabs.vue?vue&type=script&lang=ts&setup=true"

import "./myTabs.vue?vue&type=style&index=0&id=6db3dd08&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db3dd08"]])

export default __exports__